module.exports = JBrowseExports["react/jsx-runtime"];